/**
 * The answer key of a sokoban is a walkthrough. Kept apart from the form component so the
 * eagerly loaded module file never pulls the author's board into the player bundle.
 */
import { parseBoard, replay } from "./board";
import type { SokobanDefinition, SokobanSolution } from "./types";

/** Nothing typed yet: an empty walkthrough, which `validate_solution` refuses on save. */
export function emptySolution(_definition: SokobanDefinition): SokobanSolution {
  return { moves: "" };
}

/** Whether a stored value is a walkthrough at all. */
export function isWalkthrough(value: unknown): value is SokobanSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const moves = (value as { moves?: unknown }).moves;
  return typeof moves === "string" && /^[udlrUDLR]*$/.test(moves);
}

/** Reads whatever is stored, however wrong, as the moves this board can play. */
export function movesOf(value: unknown, definition: SokobanDefinition): string {
  if (!isWalkthrough(value)) return "";
  const { board, state } = parseBoard(definition.board);
  if (!state) return "";
  return replay(board, state, value.moves).moves;
}
